export default __webpack_public_path__ + "static/media/mobileimg.d644ef8b.jpg";